import {BaseWidget} from "./BaseWidget";

export class RichTextEditorWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        this.findElement().kendoEditor({
            resizable: {
                content: true,
            },
            tools: [
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "justifyLeft",
                "justifyCenter",
                "justifyRight",
                "justifyFull",
                "insertUnorderedList",
                "insertOrderedList",
                "indent",
                "outdent",
                "createLink",
                "unlink",
                "insertImage",
                "insertFile",
                "subscript",
                "superscript",
                "tableWizard",
                "createTable",
                "addRowAbove",
                "addRowBelow",
                "addColumnLeft",
                "addColumnRight",
                "deleteRow",
                "deleteColumn",
                "viewHtml",
                "formatting",
                "cleanFormatting",
                "fontName",
                "fontSize",
                "foreColor",
                "backColor",
            ],
        });
    }

    createElement(style) {
        let that = this;
        return $(`<div class="k-textbox w-100 spanned2 n-rich-text border-secondary" type='text' ${style} id="${this.elementId}" nid="${this.id}"/>`);
    }

    setValueInElement(value) {
        let that = this;
        if (!value)
            value = "";
        if (!that._kendoEditor()) {
            setTimeout(() => {
                that.setValueInElement(value);
            })
            return;
        }
        that._kendoEditor().value(value);
    }

    readValueFromElement() {
        return this._kendoEditor().value();
    }

    _kendoEditor() {
        let editor = this.findElement().data("kendoEditor");
        editor.refresh();
        return editor;
    }
}